// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__17fm-","title":"Info_title__YE5jK","selects":"Info_selects__2Die8","requiredAsterisk":"Info_requiredAsterisk__3dL50"};